<template>
    <div class="vuetable-filterbar col-md-12 step-filtrar">
        <div class="form-group">
            <b-container fluid>
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="lote"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                Lote
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="p-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="nf_ini"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                Nf Início
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="p-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="nf_fim"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                Nf fim
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="3" class="p-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="fornecedor"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                Fornecedor
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="3" class="p-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="redespacho"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                Redespacho
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="p-0">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Data Emissão Inicial"
                            reset-button
                            v-model="dt_emissao_ini"
                            class="form-control"
                            :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                            }"
                        >
                        </b-form-datepicker>
                    </b-col>

                    <b-col sm="6" md="2" class="p-0">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Data Emissão Fim"
                            reset-button
                            v-model="dt_emissao_fim"
                            class="form-control"
                            :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                            }"
                        >
                        </b-form-datepicker>
                    </b-col>

                    <b-col sm="6" md="2" class="p-0">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Data Inclusão Inicial"
                            reset-button
                            v-model="dt_ini"
                            class="form-control"
                            :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                            }"
                        >
                        </b-form-datepicker>
                    </b-col>

                    <b-col sm="6" md="2" class="p-0">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Data Inclusão Fim"
                            reset-button
                            v-model="dt_fim"
                            class="form-control"
                            :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                            }"
                        >
                        </b-form-datepicker>
                    </b-col>

                    <b-col sm="6" md="2" class="p-0">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Data Previsão Inicial"
                            reset-button
                            v-model="dt_pre_ini"
                            class="form-control"
                            :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                            }"
                        >
                        </b-form-datepicker>
                    </b-col>
                    <b-col sm="6" md="2" class="p-0">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Data Previsão Fim"
                            reset-button
                            v-model="dt_pre_fim"
                            class="form-control"
                            :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                            }"
                        >
                        </b-form-datepicker>
                    </b-col>

                    <b-col sm="6" md="2" class="p-0">
                        <b-container>
                            <b-col sm="12" md="12">
                                <b-form-checkbox
                                    v-model="atraso"
                                    value="1"
                                    unchecked-value="2"
                                >
                                    Atrasadas
                                    <span
                                        v-b-tooltip
                                        title="Se marcado irá retornar apenas as notas que estão em atraso"
                                        placement="top"
                                    >
                                        [?]
                                    </span>
                                </b-form-checkbox>
                            </b-col>
                        </b-container>
                    </b-col>

                    <b-col class="p-0 pt-1 d-flex flex-row-reverse">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button
                                    type="button"
                                    class="btn btn-secondary btn-outline"
                                    @click="doFilter"
                                    :disabled="vuetableFilterButton"
                                >
                                    Filtrar
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-secondary btn-outline"
                                    @click="resetFilter"
                                    :disabled="vuetableFilterButton"
                                >
                                    Limpar
                                </button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    data() {
        return {
            date_attributes: [
                { key: "today", highlight: true, dates: new Date() },
            ],
            isLoadingFornecedor: false,
            lote: "",
            nf_ini: "",
            nf_fim: "",
            fornecedor: "",
            dt_emissao_ini: "",
            dt_emissao_fim: "",
            dt_ini: "",
            dt_fim: "",
            dt_pre_ini: "",
            dt_pre_fim: "",
            atraso: "",
            redespacho: "",
            data_filter: [],
            helpForm: new Form({ statusRecord: [], params: [], search: "" }),
        };
    },
    mounted() {
        this.$events.$on("filter-reset", (e) => this.onFilterReset());
    },
    methods: {
        doFilter() {
            this.$store.commit("setVuetableFilterButton", true);
            this.data_filter = {
                lote: this.lote,
                nf_ini: this.nf_ini,
                nf_fim: this.nf_fim,
                fornecedor: this.fornecedor,
                dt_emissao_ini: this.formatDateSubmit(this.dt_emissao_ini),
                dt_emissao_fim: this.formatDateSubmit(this.dt_emissao_fim),
                dt_ini: this.formatDateSubmit(this.dt_ini),
                dt_fim: this.formatDateSubmit(this.dt_fim),
                dt_pre_ini: this.formatDateSubmit(this.dt_pre_ini),
                dt_pre_fim: this.formatDateSubmit(this.dt_pre_fim),
                atraso: this.atraso,
                redespacho: this.redespacho,
            };
            this.$events.fire("filter-set", this.data_filter);
        },
        onFilterReset() {
            this.lote = "";
            this.nf_ini = "";
            this.nf_fim = "";
            this.fornecedor = "";
            this.dt_emissao_ini = "";
            this.dt_emissao_fim = "";
            this.dt_ini = "";
            this.dt_fim = "";
            this.dt_pre_ini = "";
            this.dt_pre_fim = "";
            this.atraso = "";
            this.redespacho = "";
        },
        resetFilter() {
            this.onFilterReset();
            this.$events.fire("filter-reset");
        },
        formatDateSubmit(value, fmt = "DD/MM/YYYY") {
            return value == null || value == ""
                ? ""
                : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
        },
    },
    computed: {
        vuetableFilterButton: {
            get() {
                return this.$store.state.vuetable.filterButton;
            },
        },
    },
};
</script>
